import { useStudentListPublicAwards } from '@/api/v4';
import iconWisdomStone from '@/assets/icons/icon_wisdom_stone.png';
import { Popover } from '@flyer/components';
import time from '@flyer/utils/time';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';

/**
 * Quà học sinh đã đổi bằng đá tri thức — endpoint public, không cần session, nên xem
 * profile của bạn khác vẫn thấy.
 *
 * Chưa có quà nào thì trả về null: khối này chỉ hiện khi thật sự có dữ liệu, không để
 * lại ô rỗng dưới Personal achievements.
 */
export default function Awards({ profileId }: { profileId: string }) {
  const { t, lang } = useTranslation('common');

  // profileId đi vào từ bảng xếp hạng là learnerProfileId dạng chuỗi, v4 nhận số.
  const learnerProfileId = Number(profileId);
  const isValidProfileId = Number.isInteger(learnerProfileId) && learnerProfileId > 0;

  const { data } = useStudentListPublicAwards(
    {
      path: { learner_profile_id: learnerProfileId },
      query: { limit: 20, page: 1 },
    },
    { enabled: isValidProfileId },
  );

  const awards = data?.data;

  if (!awards?.length) return null;

  return (
    <div className="px-4 pb-4">
      <div className="p-3 bg-[#F9F8FF] rounded-[8px]">
        <p className="text-[#000] text-[17px] text-left">{t('ranking.awards')}</p>
        <div className="flex flex-row flex-wrap items-start gap-4 pt-2">
          {awards.map((award) => {
            return (
              <div key={award.id} className="flex flex-col items-center w-[92px]">
                <Image
                  alt={award.item_name}
                  // Quà không có ảnh riêng thì dùng chính icon đá tri thức thay chỗ:
                  // item_icon là slug của bộ icon phía client, web ranking chưa có bộ đó.
                  src={award.item_image?.url || iconWisdomStone}
                  width={64}
                  height={64}
                  className="w-[64px] h-[64px] object-contain"
                />
                <Popover content={award.item_name} onlyShowOnEllipsis zIndex={10_000}>
                  <p className="w-full pt-1 text-sm text-center text-[#321F87] truncate">
                    {award.item_name}
                  </p>
                </Popover>
                <p className="text-[#745AE8] text-xs">
                  {time(award.awarded_at)
                    .locale(lang)
                    .format(lang === 'vi' ? 'DD/MM/YYYY' : 'MMM DD, YYYY')}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
